import {Box, Text} from "@chakra-ui/react";
import {useEffect, useState} from "react";
import {Account, dataApi} from "../../api/data-api";
import {useRecoilState} from "recoil";
import {companyData, userLoginResultData} from "../../components/hooks/recoilData";

export const Lk = () => {
    const [userLoginResult] = useRecoilState(userLoginResultData);
    const [company] = useRecoilState(companyData);
    const [account, setAccount] = useState<Account>();
    useEffect(() => {
        if (userLoginResult) {
            if (company && (userLoginResult.isEmployer || userLoginResult.isOperator)) {
                dataApi.accountGet(company.ID)
                    .then((o2) => {
                        setAccount(o2);
                    })
                    .catch((err) => {
                        console.log("Login error status code is: " + err)
                    });
            }
        }
    }, [company, userLoginResult]);
    return (
        <Box>
            <Text fontSize="xl">Велкам!</Text>
            <Text fontSize="xl">{account ? `Баланс=${account.BALANCE} резерв=${account.RESERVED}` : ""}</Text>
        </Box>
    );
};